import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Typography, Spin, message } from 'antd';
import { DashboardOutlined, DatabaseOutlined, FileTextOutlined, BarChartOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { liveFollowAPI, tradeAPI } from '../services/api';

const { Title } = Typography;

const Dashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    dataSources: 0,
    topics: 0,
    tradeRecords: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [dataSourcesRes, topicsRes, followsRes] = await Promise.all([
        tradeAPI.getDataSources(),
        tradeAPI.getTopics(),
        liveFollowAPI.list(),
      ]);

      const follows = followsRes.data || [];
      let tradeRecords = 0;
      if (follows.length > 0 && follows[0] && follows[0].id) {
        try {
          const jobRes = await liveFollowAPI.getJobRecords(follows[0].id, 100, 0);
          tradeRecords = (jobRes.data || []).length;
        } catch (e) {
          tradeRecords = 0;
        }
      }

      setStats({
        dataSources: dataSourcesRes.data.length,
        topics: topicsRes.data.length,
        tradeRecords,
      });
    } catch (error) {
      message.error('获取统计数据失败');
      console.error('获取统计数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const linkCardStyle = {
    cursor: 'pointer',
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <Title level={2}>
        <DashboardOutlined style={{ marginRight: '8px' }} />
        仪表板
      </Title>

      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        <Col xs={24} sm={12} md={6}>
          <Card style={linkCardStyle} onClick={() => navigate('/master-data')}>
            <Statistic
              title="数据源"
              value={stats.dataSources}
              prefix={<DatabaseOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card style={linkCardStyle} onClick={() => navigate('/master-data?key=topics')}>
            <Statistic
              title="交易话题"
              value={stats.topics}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card style={linkCardStyle} onClick={() => navigate('/trade-records')}>
            <Statistic
              title="交易记录"
              value={stats.tradeRecords}
              prefix={<BarChartOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        <Col xs={24} lg={12}>
          <Card title="系统状态" bordered={false}>
            <p>AutoTrader管理系统运行正常</p>
            <p>后端API连接状态: <span style={{ color: 'green' }}>正常</span></p>
            <p>数据库连接状态: <span style={{ color: 'green' }}>正常</span></p>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title="快速操作" bordered={false}>
            <p style={linkCardStyle} onClick={() => navigate('/master-data')}>• 查看和管理数据源</p>
            <p style={linkCardStyle} onClick={() => navigate('/master-data?key=topics')}>• 创建和编辑交易话题</p>
            <p style={linkCardStyle} onClick={() => navigate('/trade-records')}>• 监控交易记录</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
